import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './mopay-form.scss'
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";
import { makeMopayTransaction } from '../../../services/transaction-service';

const orderSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([a-zA-Z0-9]){0,5}/,
      'PIN should be alphanumeric. No special characters allowed'
    ),
  mopayNumber: Yup.string()
    .required('Ce champs est obligatoire'),
  mopayName: Yup.string()
    .optional()
});

const MopayForm = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    // console.log(`Submitting the following data ${JSON.stringify(values)}`);
    makeMopayTransaction(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setMessage(`${res.message}. You can close this page and return to the app`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          mopayNumber: "",
          mopayName: "",
          id: userId,
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={orderSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <p>Remplissez le formulaire pour confirmer le paiement.</p>
              <p>Please fill the info to confirm the payment.</p>
            </div>
            <div className={`field`}>
              <label htmlFor="mopayNumber">Numéro de paiement (Number to pay to)</label>
              <input
                name="mopayNumber"
                id="mopayNumber"
                placeholder="Momo number"
                value={values.mopayNumber}
                onChange={handleChange} />
              {errors.mopayNumber && touched.mopayNumber ? (
                <div className="error">{errors.mopayNumber}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="mopayName">Nom de paiement (Name of recipient)</label>
              <input
                name="mopayName"
                id="mopayName"
                placeholder="Name"
                value={values.mopayName}
                onChange={handleChange} />
              {errors.mopayName && touched.mopayName ? (
                <div className="error">{errors.mopayName}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN code</label>
              <input
                type='password'
                name="pin"
                id="pin"
                placeholder="Votre code PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRMER</span>}
              {isLoading && <span>Paying ...</span>}
              <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
        </p>
      }
    </div>
  );
};

export default MopayForm;
